import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() =>({
  projectCardWarp: {
    width: '250px',
    minWidth: '250px',
    height: '250px',
    position: 'relative',
    cursor: 'pointer',
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: '#1e1e25',
    '&:hover': {
      transform: 'scale(1.02)',
      '& .isActive': {
        display: 'block !important',
      },
    }
  },
  proDetails: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    // width: '100%',
    display: 'none',
    padding: '1em',
    backgroundColor: 'rgba(255,255,255,0.4)',
    color: '#000',
  },
  proTitle: {
    fontSize: '1.5em',
    color: '#011B60',
  },
  appType: {
    fontStyle: 'italic',
   // marginTop: '-10px',
    fontSize: '.75em',
    border: '2px dashed #011B60',
    color: '#011B60',
    padding: '1px 15px',
    borderRadius: 2,
    textTransform: 'lowercase',
  },
  detailBtn: {
    backgroundColor: '#0A5FFF !important',
    color: '#fff !important',
    marginTop: '3em',
    border: '1px solid #fff'
  },
  appInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  proImage: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
}));

export default useStyles;
